var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useCallback, useEffect, useState } from "react";
import { colorTheme } from "../config";
import { LinkState, NodeState } from "../models";
import { getRandomGraph, } from "./default.config";
var Graph = /** @class */ (function () {
    function Graph(nodes, links) {
        this.nodes = nodes;
        this.links = links;
        if (this.nodes.findIndex(function (node) { return node.state === NodeState.VISITED; }) === -1) {
            this.nodes[Math.floor(Math.random() * this.nodes.length)].state =
                NodeState.VISITED;
        }
    }
    Graph.prototype.getNode = function (id) {
        for (var i = 0; i < this.nodes.length; i++) {
            if (this.nodes[i].id === id) {
                return this.nodes[i];
            }
        }
        return null;
    };
    Graph.prototype.getNodes = function (comparator) {
        return this.nodes.filter(comparator);
    };
    Graph.prototype.getComponentData = function () {
        var componentData = { nodes: [], links: [] };
        for (var i = 0; i < this.nodes.length; i++) {
            var node = this.nodes[i];
            componentData.nodes.push({
                x: node.x,
                y: node.y - 50,
                id: node.id,
                color: node.state === NodeState.VISITED
                    ? colorTheme.primary.DEFAULT
                    : colorTheme.primary.lightest,
            });
        }
        for (var i = 0; i < this.links.length; i++) {
            var link = this.links[i];
            var color = colorTheme.primary.lightest;
            switch (link.state) {
                case LinkState.POSSIBLE:
                    color = colorTheme.primary.darker;
                    break;
                case LinkState.VISITED:
                    color = colorTheme.primary.DEFAULT;
                    break;
                case LinkState.ERROR:
                    color = colorTheme.error;
                    break;
            }
            link.connection.sort();
            componentData.links.push({
                source: link.connection[0],
                target: link.connection[1],
                label: "" + link.weight,
                color: color,
            });
        }
        return componentData;
    };
    Graph.prototype.getVisitedNodes = function () {
        var visitedNodes = [];
        for (var i = 0; i < this.nodes.length; i++) {
            if (this.nodes[i].state === NodeState.VISITED) {
                visitedNodes.push(this.nodes[i]);
            }
        }
        return visitedNodes;
    };
    Graph.prototype.getConnectedLinks = function (visitedNodes) {
        var res = [];
        for (var i = 0; i < this.links.length; i++) {
            var link = this.links[i];
            for (var j = 0; j < visitedNodes.length; j++) {
                var node = visitedNodes[j];
                if (link.connection.includes(node.id)) {
                    res.push(link);
                    break;
                }
            }
        }
        return res;
    };
    Graph.prototype.refresh = function () {
        for (var li = 0; li < this.links.length; li++) {
            if (this.links[li].state !== LinkState.VISITED) {
                this.links[li].state = LinkState.DEFAULT;
            }
        }
        for (var ni = 0; ni < this.nodes.length; ni++) {
            if (this.nodes[ni].state !== NodeState.VISITED) {
                this.nodes[ni].state = NodeState.DEFAULT;
            }
        }
    };
    return Graph;
}());
export function usePrim() {
    var _a = useState(new (Graph.bind.apply(Graph, __spreadArray([void 0], getRandomGraph())))()), stateGraph = _a[0], setGraph = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), solved = _c[0], setSolved = _c[1];
    var _d = useState(3), chancesLeft = _d[0], setChancesLeft = _d[1];
    var _e = useState(false), gameOver = _e[0], setGameOver = _e[1];
    useEffect(function () {
        console.log("use effect: ", chancesLeft);
        if (chancesLeft === 0) {
            console.log("ZERO");
            var graph = new Graph(stateGraph.nodes, stateGraph.links);
            graph.links.forEach(function (link) { return link.state === LinkState.ERROR; });
            setGraph(graph);
            setGameOver(true);
        }
    }, [chancesLeft]);
    var clickLink = useCallback(function (source, target) {
        if (gameOver) {
            alert("GAME OVER. RESET");
            return;
        }
        var graph = new Graph(stateGraph.nodes, stateGraph.links);
        if (error === null) {
            setChancesLeft(3);
        }
        //remove errors and highlights
        graph.refresh();
        var visitedNodes = graph.getVisitedNodes();
        var connectedLinks = graph.getConnectedLinks(visitedNodes);
        var clickedLink = graph.links[graph.links.findIndex(function (link) {
            return link.connection.includes(source) &&
                link.connection.includes(target);
        })];
        if (clickedLink.state === LinkState.VISITED) {
            setError("You already visited this Link");
            return;
        }
        var index = connectedLinks.findIndex(function (link) {
            return link.connection.includes(source) && link.connection.includes(target);
        });
        if (index === -1) {
            clickedLink.state = LinkState.ERROR;
            setGraph(graph);
            setError("The Link is not connected to any of the visited Nodes");
            setChancesLeft(chancesLeft - 1);
            return;
        }
        var connectedLinksPossible = [];
        for (var i = 0; i < connectedLinks.length; i++) {
            var link = connectedLinks[i];
            var sourceInside = false;
            var targetInside = false;
            for (var i_1 = 0; i_1 < visitedNodes.length; i_1++) {
                if (visitedNodes[i_1].id === link.connection[0]) {
                    sourceInside = true;
                }
                if (visitedNodes[i_1].id === link.connection[1]) {
                    targetInside = true;
                }
                if (targetInside && sourceInside) {
                    break;
                }
            }
            if (!(targetInside && sourceInside)) {
                connectedLinksPossible.push(link);
            }
        }
        if (connectedLinksPossible.findIndex(function (link) {
            return link.connection.includes(source) && link.connection.includes(target);
        }) === -1) {
            clickedLink.state = LinkState.ERROR;
            setGraph(graph);
            setChancesLeft(chancesLeft - 1);
            setError("The Link is not connected to an unvisited Node");
            return;
        }
        var smallestPossible = connectedLinksPossible.sort(function (a, b) { return a.weight - b.weight; })[0].weight;
        if (clickedLink.weight > smallestPossible) {
            clickedLink.state = LinkState.ERROR;
            setGraph(graph);
            setChancesLeft(chancesLeft - 1);
            setError("This Link does not have the smallest weight");
            return;
        }
        clickedLink.state = LinkState.VISITED;
        for (var i = 0; i < graph.nodes.length; i++) {
            if (clickedLink.connection.includes(graph.nodes[i].id)) {
                graph.nodes[i].state = NodeState.VISITED;
            }
        }
        if (visitedNodes.length === graph.nodes.length - 1) {
            setSolved(true);
        }
        setError(null);
        setGraph(graph);
        return;
    }, [error, chancesLeft, gameOver, stateGraph]);
    var nextStep = useCallback(function () {
        var graph = new Graph(stateGraph.nodes, stateGraph.links);
        graph.links.forEach(function (link) {
            if (link.state === LinkState.POSSIBLE) {
                link.state = LinkState.DEFAULT;
            }
        });
        var visited = graph.nodes.filter(function (node) {
            return node.state === NodeState.VISITED;
        });
        if (visited.length === graph.nodes.length) {
            alert("Solved!");
        }
        if (visited.length === 0) {
            var randomNode = graph.nodes[Math.floor(Math.random() * graph.nodes.length)];
            randomNode.state = NodeState.VISITED;
            visited.push(randomNode);
        }
        var possibleConnections = getPossible(graph, visited);
        console.log("pos: ", possibleConnections);
        possibleConnections[0].state = LinkState.VISITED;
        possibleConnections[0].connection.forEach(function (id) {
            var node = graph.getNode(id);
            if (node) {
                node.state = NodeState.VISITED;
            }
        });
        console.log(graph);
        setGraph(graph);
    }, []);
    var reset = useCallback(function () {
        var graph = new (Graph.bind.apply(Graph, __spreadArray([void 0], getRandomGraph())))();
        graph.nodes.forEach(function (node) {
            node.state = NodeState.DEFAULT;
        });
        graph.links.forEach(function (link) {
            link.state = LinkState.DEFAULT;
        });
        setGraph(graph);
        setSolved(false);
        setError(null);
        setChancesLeft(3);
        setGameOver(false);
    }, []);
    return [
        stateGraph,
        nextStep,
        clickLink,
        reset,
        error,
        solved,
        chancesLeft,
        gameOver,
    ];
}
function getPossible(graph, visited) {
    var possible = [];
    for (var i = 0; i < visited.length; i++) {
        var node = visited[i];
        var notVisitedLinks = graph.links.filter(function (link) { return link.state !== LinkState.VISITED; });
        for (var k = 0; k < notVisitedLinks.length; k++) {
            var link = notVisitedLinks[k];
            if (link.connection[0] === node.id) {
                var node_1 = graph.getNode(link.connection[1]);
                if ((node_1 === null || node_1 === void 0 ? void 0 : node_1.state) !== NodeState.VISITED) {
                    possible.push(link);
                }
            }
            else if (link.connection[1] === node.id) {
                var node_2 = graph.getNode(link.connection[0]);
                if ((node_2 === null || node_2 === void 0 ? void 0 : node_2.state) !== NodeState.VISITED) {
                    possible.push(link);
                }
            }
        }
    }
    possible.sort(function (a, b) { return a.weight - b.weight; });
    return possible.filter(function (a) { return a.weight <= possible[0].weight; });
}
